import { COMPETITOR_ALTERNATIVES } from './data';

/** Curated high-intent comparison pages in the footer (hub + subset; not every /alternative URL). */
const FOOTER_COMPARE_SLUGS = [
  'routific-alternative',
  'onfleet-alternative',
  'shipday-alternative',
  'circuit-alternative',
  'bringg-alternative',
  'locus-alternative',
] as const;

function alternativeBySlug(slug: (typeof FOOTER_COMPARE_SLUGS)[number]) {
  const d = COMPETITOR_ALTERNATIVES.find((x) => x.pathSlug === slug);
  if (!d) throw new Error(`Missing competitor data for footer slug: ${slug}`);
  return d;
}

export const COMPARE_FOOTER_LINKS = [
  { to: '/compare', labelKey: 'compareHub' as const },
  ...FOOTER_COMPARE_SLUGS.map((slug) => {
    const d = alternativeBySlug(slug);
    return { to: `/${d.pathSlug}`, labelKey: d.footerLabelKey };
  }),
];
